<template>
    <div class="app-menu">
      <div v-for="s in titles"
        :key="s.title"
        class="app-menu-item"
        :style="{
          'max-width': `${s.width}rem`,
          'width': `${s.width}rem`,
          'height': `${itemHeight}rem`
        }"
        @mouseenter="mouseoverTitle(s.title)"
        @mouseleave="mouseoutTitle">
        <router-link class="app-menu-item-title"
          :id="s.unique"
          :style="{
            color: color,
            'font-weight': `${s.title === title ? highlightFontWeight : fontWeight}`
          }"
          :to="s.path">
          {{s.title}}
        </router-link>
        <div class="app-menu-item-sub-container"
        v-if="selectTitle === s.title && s.subTitles.length > 0">
          <a 
          href="javascript: void(0)"
          @click="goto(s.path, ss.anchor)"
          class="app-menu-item-sub-container-title"
          :style="{
            color: color,
            'font-weight': fontWeight
          }"
          v-for="ss in s.subTitles"
          :key="ss.title">
          {{ss.title}}
          </a>
        </div>
      </div>
      <router-view></router-view>
    </div>
</template>
  
<script>

export default {
    name: "Menu",
    props: {
      title: {
        type: String,
        required: true
      },
      color: {
        type: String,
        default: '#FFFFFF'
      },
      subColor: {
        type: String,
        default: '#FFFFFF'
      },
      highlightFontWeight: {
        type: Number,
        default: 500
      },
      fontWeight: {
        type: Number,
        default: 300
      },
    },
    data() {
      return {
        itemHeight: 3.2,
        titles: [
          { title: '首页', unique: 'home', path: '/', width: 1, subTitles: [] },
          { title: '关于我们', unique: 'about', path: '/about', width: 2, subTitles: 
          [
            { title: '品牌简介', anchor: 'video', },
            { title: '品牌含义', anchor: 'explain', },
            { title: '品牌理念', anchor: 'idea', },
            { title: '品牌愿景', anchor: 'vision', },
            { title: '品牌历程', anchor: 'story', },
          ] },
          { title: '产品', unique: 'product', path: '/product', width: 1, subTitles: 
          [
            { title: '胶原棒', anchor: 'product-1' },
            { title: '水光弹面膜', anchor: 'product-2' },
            { title: '胶原精华', anchor: 'product-3' },
            { title: '广藿香面霜', anchor: 'product-4' },
            { title: '胶原面霜', anchor: 'product-5' },
            { title: '胶原眼精华', anchor: 'product-6' },
            { title: '胶原面膜', anchor: 'product-7' },
            { title: '胶原水', anchor: 'product-8' },
            { title: '姜根养发套装', anchor: 'product-9' },
            { title: '姜根养发旅行装', anchor: 'product-10' },
          ] },
          { title: '科研', unique: 'study', path: '/study', width: 1, subTitles: 
          [
            { title: '专利技术', anchor: 'study-1' },
            { title: '权威认证', anchor: 'study-2' },
          ] },
          { title: '新闻资讯', unique: 'news', path: '/news', width: 2, subTitles: 
          [
            { title: '企业资讯', anchor: 'news-1' },
            { title: '行业动态', anchor: 'news-2' },
            { title: '品牌动态', anchor: 'news-3' },
          ] },
          { title: '服务中心', unique: 'service', path: '/service', width: 2, subTitles: 
          [
            { title: '防伪查询', anchor: 'service-1' },
            { title: '门店地址', anchor: 'service-2' },
            { title: '售后服务', anchor: 'service-3' },
          ] },
          { title: '玩转MINIPIKA', unique: 'ways', path: '/ways', width: 2.5, subTitles: 
          [
            { title: '品牌故事', anchor: 'ways-1' },
            { title: '玩转攻略', anchor: 'ways-2' },
          ] }
        ],
        selectTitle: '',
      }
    },
    mounted() {
      this.$nextTick(() => {
        if (this.title) {
          this.titles.forEach(item => {
            const { title, unique } = item
            if (this.title === title) {
              const e = document.getElementById(unique)
              e.scrollIntoView()
            }
          })
        }
      })
    },
    methods: {
      mouseoverTitle(e) {
        this.selectTitle = e
        this.itemHeight = 5
      },
      mouseoutTitle() {
        this.selectTitle = ''
        this.itemHeight = 3.2
      },
      goto(path, anchor) {
        if (this.$route.path === path) {
          if (anchor) {
            const e = document.getElementById(anchor)
            e.scrollIntoView()
          }
        } else {
          this.$router.push({path, hash: anchor})
        }
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .app-menu {
    z-index: 5;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    overflow-y: visible;
    overflow-x: scroll;
    display: flex;
    justify-content: flex-start;
    column-gap: 0.5rem;
    box-sizing: border-box;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    background-color: transparent;
    &-item {
      overflow-x: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      &-title {
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-size: 0.26rem;
        line-height: 0.32rem;
        text-align: center;
        word-break: keep-all;
      }
      &-sub-container {
        position: absolute;
        top: 0.42rem;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        row-gap: 0.1rem;
        padding-top: 0.1rem;
        padding-bottom: 0.1rem;
        padding-left: 0.16rem;
        padding-right: 0.16rem;
        box-sizing: border-box;
        background-image: url('../assets/img/menu-sub-bg.png');
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        border-radius: 0.05rem;
        &-title {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-size: 0.24rem;
          line-height: 0.3rem;
          text-align: center;
          word-break: keep-all;
        }
      }
    }
  }
  </style>